import { Validators } from '@quickbit/qb-design-system';
import { Platform } from '../types';

export const platformValidators: Validators<Platform, Platform> = {};
